<!-- popup.component.html -->
<div class="container p-0 m-0">
  <ng-container *ngIf="(campaigns$ | async) as campaigns; else loading">
    <!-- Si hay 2+ campañas => carrusel -->
    <don-campaign-carousel
      *ngIf="campaigns.length > 1; else single"
      [campaigns]="campaigns"
      [selectedId]="(selectedId$ | async) || null"
      (select)="onSelectCampaign($event)">
    </don-campaign-carousel>

    <!-- Si solo hay 1 => summary plano -->
    <ng-template #single>
      <don-campaign-summary [campaign]="campaigns[0]"></don-campaign-summary>
    </ng-template>
  </ng-container>

  <ng-template #loading>
    <div class="p-4 text-center text-muted small">Loading campaigns…</div>
  </ng-template>

  <div class="p-4">
    <don-pop-up-form
      [price]="(draftPrice$ | async)!"
      [canAcceptRecurring]="(canAcceptRecurring$ | async) ?? false"
      (submitted)="onPopUpSubmit($event)">
    </don-pop-up-form>
  </div>
</div>
